import NotFoundPage from './NotFoundPage.container'

export default NotFoundPage
